import * as FC from "@fluentui/react-components";
import * as IC from "@fluentui/react-icons";
import { useCommonStyles } from "../../../style_util";
import { SimpleGrid, useSimpleGrid } from "../../../components/simple_grid";
import { useDrawer } from "../../../components/use_drawer";
import { bindInputValue, useInfo } from "../../../form_utils";
import { DeleteButton } from "../../../components/delete_button";
import { useContext } from "react";
import { Context } from "../../../context";
import { apiClient } from "../../../services/api";
import { describeWriteError } from "../../../services/write_errors";
import {
    ManuTurbineDef,
    listManuTurbine,
} from "../../../services/manu_turbine_service";
import { getCurrentFieldId, getCurrentFieldIdFromNew } from "../../../workspace";

const ManuTurbineForm = ({ item, onChange }) => {
    const { user } = useContext(Context);
    const { info, setInfo } = useInfo();
    const v = bindInputValue(item, info, setInfo);
    // Catalogue writes resolve their target tenant from ?tenantId= and the backend refuses to
    // guess one, so without this every create/update/delete here is a 400 TenantIdRequired.
    const tenantId = user?.tenantId;

    const onDelete = async () => {
        try {
            await apiClient.deleteManuTurbine(item.id, tenantId);
            onChange();
        } catch (error) {
            console.error("Failed to delete turbine manufacturer:", error);
            alert("删除失败: " + describeWriteError(error));
        }
    };
    const onSave = async () => {
        try {
        if (item) {
            await apiClient.updateManuTurbine(item.id, info, tenantId);
            onChange();
        } else {
            const fieldId = getCurrentFieldIdFromNew() || getCurrentFieldId();
            // Extract numeric ID from SurrealDB record format (e.g., "field_item:2" -> 2)
            const numericFieldId = typeof fieldId === 'string' && fieldId.includes(':') 
                ? parseInt(fieldId.split(':')[1]) 
                : fieldId;
            let _info = { 
                Name: info.name || '',
                FieldItemId: numericFieldId
            };
            console.log('Creating manu_turbine with data:', _info);
            await apiClient.createManuTurbine(_info, tenantId);
            onChange();
        }
        } catch (error) {
            console.error("Failed to save turbine manufacturer:", error);
            alert("保存失败: " + describeWriteError(error));
        }
    };

    const commonStyles = useCommonStyles();
    return (
        <div className={commonStyles.form}>
            <FC.Field label="厂商名称">
                <FC.Input {...v("name")} />
            </FC.Field>

            <FC.Divider />
            {item && <DeleteButton onClick={onDelete} />}
            <FC.Button onClick={onSave} disabled={!info} appearance="primary">
                {(item && "保存") || "创建"}
            </FC.Button>
        </div>
    );
};
export const ManuTurbineManagement = () => {
    const { openDrawer, closeDrawer, drawer } = useDrawer();

    const { items, refresh, SearchInput } = useSimpleGrid({
        listItems: listManuTurbine,
        placeholder: "按厂商名称搜索...",
    });

    const onFormChange = () => {
        refresh();
        closeDrawer();
    };
    const onNewManuTurbine = () => {
        openDrawer({
            header: "创建风机厂商",
            body: <ManuTurbineForm item={null} onChange={onFormChange} />,
        });
    };
    const columns = [
        ManuTurbineDef.createTableColumn("name"),
        ManuTurbineDef.createOpsColumn({
            renderCell: (item) => {
                const onClick = () => {
                    openDrawer({
                        header: "风机厂商详情",
                        body: (
                            <ManuTurbineForm
                                item={item}
                                onChange={onFormChange}
                            />
                        ),
                    });
                };
                return (
                    <FC.TableCellLayout>
                        <FC.Button
                            appearance="subtle"
                            icon={<IC.MoreCircleFilled />}
                            onClick={onClick}
                        />
                    </FC.TableCellLayout>
                );
            },
        }),
    ];
    const commonStyles = useCommonStyles();
    return (
        <div className={commonStyles.root}>
            <div className={commonStyles.row}>
                <FC.Label>快速检索</FC.Label>
                <SearchInput />
                <FC.Button appearance="primary" onClick={onNewManuTurbine}>
                    创建风机厂商
                </FC.Button>
            </div>
            <SimpleGrid items={items} columns={columns} />
            {drawer}
        </div>
    );
};
